/**
 * Utilities for gating marketing pixels by consent.
 *
 * On web, delegates to the existing CookieScript consent system.
 * On native (Capacitor iOS / Android), marketing pixels are disabled
 * unconditionally: we deliberately do NOT present an App Tracking
 * Transparency prompt, and we do not load any of the third-party tracking
 * pixels (Meta / Google / TikTok / Snap / Reddit) on the native app.
 * The privacy manifest declares the app as non-tracking.
 */
import { canTrackUser } from "./consent";

function isCapacitorNative(): boolean {
  if (typeof window === "undefined") return false;
  const cap = (window as unknown as Record<string, unknown>).Capacitor;
  if (!cap || typeof cap !== "object") return false;
  const isNative = (cap as Record<string, unknown>).isNativePlatform;
  return typeof isNative === "function" && (isNative as () => boolean)();
}

/**
 * Whether marketing pixel scripts should be loaded.
 * - On native (iOS/Android): never — we don't do cross-company tracking in
 *   the native app, so no pixels and no ATT prompt.
 * - On web: delegates to CookieScript consent via canTrackUser().
 */
export async function canLoadMarketingPixels(): Promise<boolean> {
  if (isCapacitorNative()) return false;
  return canTrackUser();
}
